// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d20c0555","997":"e1d3b1e5"}[chunkId] + ".chunk.js";
};